<template lang="pug">
  form.card.mb-2(@submit.prevent='save')
    .card-header
      form-group(:validation='$v.item.titulo' v-if='editing', :label="'ordem_servico_assunto_informacao.titulo' | tModel")
        input.form-input(type='text' v-model='$v.item.titulo.$model' :placeholder="'ordem_servico_assunto_informacao.titulo' | tModel")
      .card-title.h5(v-else) {{ item.titulo }}
    .card-body
      form-group(:validation='$v.item.descricao' v-if='editing', :label="'ordem_servico_assunto_informacao.descricao' | tModel")
        textarea.form-input(v-model='$v.item.descricao.$model' :placeholder="'ordem_servico_assunto_informacao.descricao' | tModel")
      p.text-long(v-else) {{ item.descricao }}
    .card-footer.text-right
      a.btn.btn-link.text-error(@click='destroy')
        btn-content(name='delete')
      button.btn.btn-link(type='submit' :disabled='$v.$invalid' v-if='editing')
        btn-content(label='Ok')
      a.btn.btn-link.text-warning(@click='toEdit' v-else)
        btn-content(name='edit')
</template>

<script>
import AssuntoInformacao from '@/models/AssuntoInformacao'

export default {
  props: {
    item: { type: Object, required: true },
    index: { type: Number, required: true },
    editing: { type: Boolean },
  },

  validations: {
    item: AssuntoInformacao.validations,
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },

  methods: {
    save() {
      this.$emit('save', this.item, this.index)
    },

    toEdit() {
      this.$emit('toedit', this.item, this.index)
    },

    destroy() {
      if (!this.item.id && this.$v.$invalid) {
        this.$emit('destroy', this.item, this.index)
        return
      }
      const options = { cancelLabel: 'Não', title: 'Confirmação' }
      this.$dialogs.confirm('Tem certeza?', options).then(res => {
        if (res.ok) {
          this.$emit('destroy', this.item, this.index)
        }
      })
    },
  },
}
</script>
